
import { defineComponent } from 'vue';
import { Modal } from 'vue-bootstrap';
import CloseIcon from '@/lib/components/ListActions/Partials/CloseIcon.vue';
import { trans } from '@/services/global/translations.interface';
import { ModalEvents } from '@/lib/Modal/ModalEvents';

export default defineComponent({
	components: {
		CloseIcon,
		Modal,
	},
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
		confirmButtonLabel: {
			type: String,
			default: null,
		},
		cancelButtonLabel: {
			type: String,
			default: null,
		},
		confirmDisabled: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		return {
			lang: trans,
			ModalEvents,
		};
	},
});
